export default "__VITE_ASSET__CKwLbm8t__";